import { Team } from "../types/Team";

/**
 * Why a Team's delete control is disabled, or undefined when it can be
 * deleted. A Team with users can't be deleted (product decision, SEG review
 * Oct 2026); the control stays visible but greyed, with this as its tooltip.
 */
export const teamDeleteBlockedReason = (
  team: Team,
  canManageTeams: boolean
): string | undefined =>
  !canManageTeams
    ? "You don't have permission to manage teams"
    : team.user_count > 0
    ? `Remove the ${team.user_count} user${
        team.user_count === 1 ? "" : "s"
      } from this Team before deleting it`
    : undefined;
